/**
 * Model label dropdown (CDN-2479).
 *
 * The note of the model label is an absolute box over the content, so it acts
 * as a dropdown: Escape closes it and gives the focus back to the chip, and a
 * click outside the label closes it. Opening and closing with the chip stay
 * native <details> behaviour, so the label still works without this script.
 */
(function () {
	"use strict";

	var SELECTOR = "details.model-label";

	function openLabels() {
		return document.querySelectorAll(SELECTOR + "[open]");
	}

	document.addEventListener("keydown", function (event) {
		if (event.key !== "Escape") {
			return;
		}

		openLabels().forEach(function (label) {
			label.open = false;

			if (label.contains(document.activeElement)) {
				var summary = label.querySelector("summary");
				if (summary) {
					summary.focus();
				}
			}
		});
	});

	document.addEventListener("click", function (event) {
		openLabels().forEach(function (label) {
			if (!label.contains(event.target)) {
				label.open = false;
			}
		});
	});
})();
